import Toolbar from "react-big-calendar/lib/Toolbar";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

export class CalendarCustomToolbar extends Toolbar {
	render() {
		return (
			<div>
				<div className="text-center font-weight-bold text-white">{this.props.label}</div>
				<div className="d-flex flex-column flex-sm-row align-items-center align-items-sm-baseline justify-content-sm-between my-3">
					<div className="d-flex">
						<div
							onClick={() => this.navigate("PREV")}
							className="border btn d-flex align-items-center rounded border-info px-2 text-info"
							style={{
								cursor: "pointer",
								paddingBottom: 7,
								paddingTop: 7,
								marginLeft: 1.5,
								marginRight: 1.5,
							}}
						>
							<FiChevronLeft style={{ fontSize: 16 }} />
						</div>

						<div
							onClick={() => this.navigate("TODAY")}
							className="border btn d-flex align-items-center rounded border-info px-2 text-info"
							style={{
								cursor: "pointer",
								paddingBottom: 7,
								paddingTop: 7,
								marginLeft: 1.5,
								marginRight: 1.5,
							}}
						>
							Today
						</div>
						<div
							onClick={() => this.navigate("NEXT")}
							className="border btn d-flex align-items-center rounded border-info px-2 text-info"
							style={{
								cursor: "pointer",
								paddingBottom: 7,
								paddingTop: 7,
								marginLeft: 1.5,
								marginRight: 1.5,
							}}
						>
							<FiChevronRight style={{ fontSize: 16 }} />
						</div>
					</div>
					<div className="d-flex">
						<div
							onClick={this.view.bind(null, "month")}
							className="border btn d-flex align-items-center rounded border-info px-2 text-info"
							style={{
								cursor: "pointer",
								paddingBottom: 7,
								paddingTop: 7,
								marginLeft: 1.5,
								marginRight: 1.5,
							}}
						>
							Month
						</div>
						<div
							onClick={this.view.bind(null, "week")}
							className="border btn d-flex align-items-center rounded border-info px-2 text-info"
							style={{
								cursor: "pointer",
								paddingBottom: 7,
								paddingTop: 7,
								marginLeft: 1.5,
								marginRight: 1.5,
							}}
						>
							Week
						</div>
						<div
							onClick={this.view.bind(null, "day")}
							className="border btn d-flex align-items-center rounded border-info px-2 text-info"
							style={{
								cursor: "pointer",
								paddingBottom: 7,
								paddingTop: 7,
								marginLeft: 1.5,
								marginRight: 1.5,
							}}
						>
							Day
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export class CalendarCustomToolbarWithoutViewSelection extends Toolbar {
	render() {
		return (
			<div>
				<h5 className="text-center font-weight-bold text-white">{this.props.label}</h5>
				<div className="d-flex flex-column flex-sm-row align-items-center align-items-sm-baseline">
					<div className="d-flex">
						<div
							onClick={() => this.navigate("PREV")}
							className="border btn d-flex align-items-center rounded border-info p-1 text-info"
							style={{
								cursor: "pointer",
								paddingBottom: 7,
								paddingTop: 7,
								marginLeft: 1.5,
								marginRight: 1.5,
							}}
						>
							<FiChevronLeft style={{ fontSize: 16 }} />
						</div>
						<div
							onClick={() => this.navigate("TODAY")}
							className="border btn d-flex align-items-center rounded border-info p-1 text-info"
							style={{
								cursor: "pointer",
								paddingBottom: 7,
								paddingTop: 7,
								marginLeft: 1.5,
								marginRight: 1.5,
							}}
						>
							Today
						</div>
						<div
							onClick={() => this.navigate("NEXT")}
							className="border btn d-flex align-items-center rounded border-info p-1 text-info"
							style={{
								cursor: "pointer",
								paddingBottom: 7,
								paddingTop: 7,
								marginLeft: 1.5,
								marginRight: 1.5,
							}}
						>
							<FiChevronRight style={{ fontSize: 16 }} />
						</div>
					</div>
				</div>
			</div>
		);
	}
}
